<template>
  <div class="navigation">
    <input
      id="navi-toggle"
      type="checkbox"
      class="navigation__checkbox"
    >
    <label
      for="navi-toggle"
      class="navigation__button"
    >
      <span class="navigation__icon"> &nbsp;</span>
    </label>
    <div class="navigation__background">
            &nbsp;
    </div>
    <nav class="navigation__nav">
      <ul class="navigation__list">
        <li class="navigation__item">
          <router-link
            class="navigation__link"
            :to=" { name: 'Home' }"
            @click.native="closeNav()"
          >
            Home
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link
            class="navigation__link"
            :to="{ name: 'Blog' }"
            @click.native="closeNav()"
          >
            Blog
          </router-link>
        </li>
        <li class="navigation__item">
          <router-link
            class="navigation__link"
            :to="{ name: 'Design' }"
            @click.native="closeNav()"
          >
            Web Design
          </router-link>
          </li>
        <li class="navigation__item">
          <router-link
            class="navigation__link"
            :to="{ name: 'About' }"
            @click.native="closeNav()"
          >
            About
          </router-link>
        </li>
        <li class="navigation__item">
          <router-link
            class="navigation__link"
            :to="{ name: 'Contact' }"
            @click.native="closeNav()"
          >
            Contact
          </router-link>
        </li>
        <li class="navigation__item">
          <router-link
            v-if="isAdmin"
            class="navigation__link"
            :to="{ name: 'Admin' }"
            @click.native="closeNav()"
          >
            Admin
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link
            v-if="user"
            class="navigation__link"
            :to=" { name: 'Profile' }"
            @click.native="closeNav()"
          >
            Profile
          </router-link>
        </li>
        <li
          v-if="user"
          class="navigation__item"
        >
          <a
            href="#"
            class="navigation__link"
            @click="logout"
          >
            LogOut
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import {auth} from 'firebase/app'
import db from '@/firebase/init'
export default {
  name: 'Navigation',
  data () {
    return {
      user: null,
      additionaluserinfo: null,
      isAdmin: false,
      isSuperAdmin: false
    }
  },
  created () {
    auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user
        console.log(this.user)
        console.log('user has changed')
        this.user = user
        console.log(this.user)
          auth()
          .currentUser.getIdTokenResult()
          .then((tokenResult) => {
            this.$store.dispatch('setAdditionalUserInfo', tokenResult.claims)
            this.additionaluserinfo = tokenResult.claims
            tokenResult.claims.superadmin === true || tokenResult.claims.admin === true ? this.isAdmin = true : this.isAdmin = false
            tokenResult.claims.superadmin === true ? this.isSuperAdmin = true : this.isSuperAdmin = false
            console.log('user has changed')
            console.log(tokenResult)
          })
          .catch((error) => {
            console.log('Error getting documents: ', error)
          })
      }
    })
  },
  methods: {
    closeNav () {
      document.getElementById('navi-toggle').checked = false
    },
    logout () {
      auth().signOut()
        .then(() => {
          // this.$router.go()
          this.$router.push({
            name: 'Login'
          }).catch(err => {
            console.log(err)
          })
        })
      this.$store.commit('resetUserState')
    }
  }
}
</script>
